export enum SocialLinkType {
    Facebook,
    Instagram,
    X,
    LinkedIn,
    TikTok,
    YouTube,
}